import React, { Fragment } from 'react';
import { Flex } from '@marvelapp/ui';
import { SpecsPanel, SpecsBorderItem, SpecsPanelProperty, } from '@marvelapp/ui-internal';
import ColorFill from './sidebar/ColorFill';
import Measurement from '../../containers/handoff/Measurement';
export default function PanelShadows(_a) {
    var shadows = _a.shadows, innerShadows = _a.innerShadows;
    return (React.createElement(Fragment, null,
        shadows.length ? (React.createElement(SpecsPanel, { title: "Shadows" }, shadows.map(function (shadow, index) { return (
        // eslint-disable-next-line
        React.createElement(Shadow, { shadow: shadow, key: index })); }))) : null,
        innerShadows.length ? (React.createElement(SpecsPanel, { title: "Inner Shadows" }, innerShadows.map(function (shadow, index) { return (
        // eslint-disable-next-line
        React.createElement(Shadow, { shadow: shadow, key: index })); }))) : null));
}
export function Shadow(_a) {
    var shadow = _a.shadow, index = _a.index;
    return (React.createElement(SpecsBorderItem, { justifyContent: "space-between", key: index, marginBottom: 10, paddingBottom: 10 },
        React.createElement(ColorFill, { color: shadow.color.rgbaValues, wordBreak: "keep-all" }),
        React.createElement(Flex, null,
            React.createElement(SpecsPanelProperty, { label: "X", marginRight: 3, transitionType: "icon", wordBreak: "keep-all" },
                React.createElement(Measurement, { includeUnitIfZero: true, value: shadow.offset[0] })),
            React.createElement(SpecsPanelProperty, { label: "Y", marginRight: 3, transitionType: "icon", wordBreak: "keep-all" },
                React.createElement(Measurement, { includeUnitIfZero: true, value: shadow.offset[1] })),
            React.createElement(SpecsPanelProperty, { label: "B", marginRight: 3, transitionType: "icon", wordBreak: "keep-all" },
                React.createElement(Measurement, { includeUnitIfZero: true, value: shadow.blur })),
            React.createElement(SpecsPanelProperty, { label: "S", transitionType: "icon", wordBreak: "keep-all" },
                React.createElement(Measurement, { includeUnitIfZero: true, value: shadow.shadowSpread })))));
}
